import React from "react";
import { ProjectsCard, ProjectsContainer, ProjectsH1, ProjectsH2, ProjectsIcon, ProjectsWrapper } from "./ProjectsElements";
import Icon1 from "../../images/projects/madero.png";
import Icon2 from "../../images/projects/sura.png";
import Icon3 from "../../images/projects/municipalidad.png";
import Icon4 from "../../images/projects/life.png";
import Icon5 from "../../images/projects/yuhmak.png";
import Icon6 from "../../images/projects/rrhh.png";

export const Projects = () => {
  return (
    <ProjectsContainer id="projects">
      <ProjectsH1>Nuestros trabajos</ProjectsH1>
      <ProjectsWrapper>
        <ProjectsCard href="https://www.asesoresmadero.com/" target="_blank" rel="noopener noreferrer">
          <ProjectsIcon src={Icon1} />
          <ProjectsH2>Madero Asesores de Seguros</ProjectsH2>
        </ProjectsCard>
        <ProjectsCard href="https://seguros.sura.cl/" target="_blank" rel="noopener noreferrer">
          <ProjectsIcon src={Icon2} />
          <ProjectsH2>Seguros Sura</ProjectsH2>
        </ProjectsCard>
        <ProjectsCard href="https://municipalidadsalta.gob.ar/" target="_blank" rel="noopener noreferrer">
          <ProjectsIcon src={Icon3} />
          <ProjectsH2>Municipalidad de Salta</ProjectsH2>
        </ProjectsCard>
        <ProjectsCard href="https://www.lifeseguros.com.ar/" target="_blank" rel="noopener noreferrer">
          <ProjectsIcon src={Icon4} />
          <ProjectsH2>Life Seguros</ProjectsH2>
        </ProjectsCard>
        <ProjectsCard href="https://www.yuhmak.com/" target="_blank" rel="noopener noreferrer">
          <ProjectsIcon src={Icon5} />
          <ProjectsH2>Yuhmak</ProjectsH2>
        </ProjectsCard>
        <ProjectsCard href="https://www.psicotecnicosrh.com.ar/" target="_blank" rel="noopener noreferrer">
          <ProjectsIcon src={Icon6} />
          <ProjectsH2>Psicotécnicos RH</ProjectsH2>
        </ProjectsCard>
      </ProjectsWrapper>
    </ProjectsContainer>
  );
};
